module.exports = __webpack_public_path__ + "img/logo.df9fe0bb.png";